import React from 'react';

import Divider from '~/components/ui/atoms/Divider';
import cn from '~/Utils/cn';

import { useMiniDrawer } from './MiniDrawerContext';
import type { MiniDrawerDividerProps } from './types';

const MiniDrawerDivider: React.FC<MiniDrawerDividerProps> = ({ className }) => {
  const context = useMiniDrawer();
  const dividerClassName = context.dividerClassName;

  return <Divider className={cn('my-8', dividerClassName, className)} />;
};

export default MiniDrawerDivider;
